"use strict";
/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrowCUpIcon24Regular = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var forwardRef_1 = require("../../helpers/forwardRef");
var BaseIcon_1 = require("../../internal/BaseIcon");
exports.ArrowCUpIcon24Regular = forwardRef_1.forwardRef('ArrowCUpIcon24Regular', function (props, ref) {
    return (react_1.default.createElement(BaseIcon_1.BaseIcon, tslib_1.__assign({ ref: ref, viewBoxSize: 24 }, props),
        react_1.default.createElement("path", { d: "M3.383 16.119a.875.875 0 0 1 0-1.238L9.79 8.474a3.125 3.125 0 0 1 4.42 0l6.406 6.407a.875.875 0 1 1-1.237 1.238l-6.407-6.407a1.375 1.375 0 0 0-1.945 0l-6.406 6.407a.875.875 0 0 1-1.238 0Z" })));
});
